


















































import {computed, defineComponent, onMounted, reactive, ref} from '@vue/composition-api'
import request from '@/utils/request';
import PageWrapper from '@/components/PageWrapper/index.vue';
import waves from '@/directive/waves'
import Import from './import.vue';
import {ApiResponse} from "@/api/api";
import {UploadPrice} from "./index";

export default defineComponent({
  name: 'inventoryQuery',
  components: {Import, PageWrapper},
  directives: {waves},
  setup() {
    const searchFormRef = ref(null)
    const searchForm = reactive({
      xhname: '',
      xhname_ct: '',
      xhname_nct: '',
    })
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref<number>(1)
    const list = ref([])
    const listLoading = ref(false)
    const importLoading = ref(false)
    const dialogImport = ref(false)
    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const getList = () => {
      listLoading.value = false
      request<ApiResponse<UploadPrice[]>>({
        url: 'overseas_price_list.yy',
        method: 'post',
        params: selectPage,
        data: searchForm
      }).then(res => {
        const {code, data, total} = res
        if (code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
        }
      })
    }

    onMounted(() => {
      getList()
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getList()

    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getList()
    }


    const handleImport = () => {
      dialogImport.value = true
    }


    const handleImportClose = () => {
      dialogImport.value = false
    }

    const handleUpload = () => {
      dialogImport.value = false
      getList()
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getList()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getList()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }


    return {
      dialogImport,
      list,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      importLoading,
      listLoading,
      searchFormRef,
      closeSearch,
      handleSearchBtn,
      handleResetBtn,
      handleUpload,
      handleImportClose,
      handleImport,
      pageSizeChange,
      pageCurrentChange,
    };
  }
})
